import { Container } from "@octopus-energy/coral/atoms"
import { animate, motion, useSpring, useTransform } from "framer-motion"
import { Text } from "../Text"
import { AnimatedNumberContainer } from "./AnimatedNumber.styled"

type AnimatedNumberProps = {
    target: string | number
    final: string | number
    suffix?: string
}

export function AnimatedNumber({ target = 0, final, suffix }: AnimatedNumberProps) {
    const count = useSpring(0, { mass: 0.8, stiffness: 75, damping: 15 })
    const rounded = useTransform(count, (latest) => Math.round(latest).toLocaleString())

    const animateCount = () => {
        void animate(count, Number(target), {
            duration: 3,
        })
    }

    return (
        <Text showcased>
            <AnimatedNumberContainer>
                <span>
                    <motion.span onViewportEnter={animateCount}>{rounded}</motion.span>
                    {suffix}
                </span>
                <Container
                    height={0}
                    overflow="hidden"
                >
                    {final}
                </Container>
            </AnimatedNumberContainer>
        </Text>
    )
}
